<template>
    <div class="text-center">
      <!-- <v-btn
        append-icon="mdi-open-in-new"
        color="deep-purple-accent-4"
        @click="overlay = !overlay"
      >
        Logging out....
      </v-btn> -->
  
      <v-overlay
        :model-value="overlay"
        class="align-center justify-center"
        persistent
      > 
     <h4 class="text-center text-yellow"> Loading ...</h4>
        <v-progress-circular
          color="primary"
          size="120"
          indeterminate
        >
        <v-avatar color="info" size="100px">
            <v-img
                alt="John"
                :src="require('../assets/fabicon_int.png')"
            ></v-img>
        </v-avatar>
        </v-progress-circular>
        
      </v-overlay>
    </div>
</template>
<script>
    export default {
        name:"LoadingOverlay",
        props: ['toggleLoader'],
        data() {
            return {
            overlay: this.toggleLoader,
            };
        },
        // watch: {
        //     toggleLoader(val) {
        //         this.overlay = val;
        //         setTimeout(() => {
        //             this.overlay = val;
        //         }, 5000);
        //     },
        // },
        watch: {
                toggleLoader(val) {
                this.overlay = val;
                }
        },
        methods: {
        }
    }
</script>